import React, { useState } from 'react';
import { Button, Loader, Segment, Header} from 'semantic-ui-react';
import PDFViewer from '../MediaAssets/PDFViewer';
import { toast } from 'react-toastify';

const Scan = () => {
  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  const handleScan = () => {
    setLoading(true);
    // Simulate a scanning process with a timeout
    setTimeout(() => {
      // Simulate setting the PDF URL based on some logic
      setPreview('https://res.cloudinary.com/drvaemi9t/image/upload/v1724851372/nrnu7fqrsklevntlhfzs.pdf'); // Replace this with actual logic to get a PDF URL
      setLoading(false);
    }, 2000); // Simulate a 2-second delay
  };

  const handleRefresh = () => {
    window.location.reload();
  }

  const handleSave = () => {
    preview !== "" ? toast.info("Document Saved Successfully") : toast.error("The documents have yet to be scanned. Please click Scan button to Scan the document");
  }
 
  return (
    <div style={{marginTop:"40px"}}>
      <Segment style={{ margin: "20px", padding: "20px" }}>
        <Header as='h2' >Document Scanner</Header>
              <Button primary onClick={handleScan} >
                Scan
              </Button>
              <Button color='green' onClick={handleSave} >
                Save
              </Button>
              <Button color='yellow' onClick={handleRefresh} >
                Refresh
              </Button>

        <div style={{ margin: "20px 0", position: 'relative', height: "80vh", maxWidth: "1000px"}}>
          {loading ? (
            <div style={{ textAlign: "center", marginTop: "20%" }}>
              <Loader active inline="centered" />
            </div>
          ) : (
            preview === "" ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                The documents have yet to be scanned. Please click Scan button to Scan the document
              </div>
            ) : (
              <PDFViewer pdfUrl={preview} />
            )
          )}
        </div>
      </Segment>
    </div>
  );
};

export default Scan;
